/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_NotificationsInputs */

const he_nav_notifications = /** @type {(inputs: Nav_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות`)
};

const en_nav_notifications = /** @type {(inputs: Nav_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Nav_NotificationsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_notifications = /** @type {((inputs?: Nav_NotificationsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_NotificationsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_nav_notifications(inputs)
	return en_nav_notifications(inputs)
});